import React from "react";
import { ContributionLimitsContainer } from "../../../containers";

const ContributionLimit = (props) => {
  return <ContributionLimitsContainer {...props} />;
};

export default ContributionLimit;
